import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import MuiButton from '@material-ui/core/Button';
import { darken } from '@material-ui/core/styles/colorManipulator';
import { forwardRef } from 'react';
import { makeStyles } from '../../themes';
import { withDefaultPropsAndStyles } from '../utils';
export const PrimaryButton = withDefaultPropsAndStyles('PrimaryButton', MuiButton, {
    defaultProps: {
        color: 'secondary',
        variant: 'contained',
    },
});
export const SecondaryButton = withDefaultPropsAndStyles('SecondaryButton', MuiButton, {
    defaultProps: {
        color: 'secondary',
        variant: 'outlined',
    },
});
export const TertiaryButton = withDefaultPropsAndStyles('TertiaryButton', MuiButton, {
    defaultProps: {
        variant: 'text',
        color: 'primary',
    },
    styles: (theme) => ({
        root: {
            backgroundColor: theme.palette.liquidity.grey25,
            color: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: theme.palette.liquidity.grey10,
            },
        },
    }),
});
const useStyles = makeStyles(({ palette }) => ({
    inverse: {
        color: ({ color }) => (color === 'secondary' ? palette.secondary.contrastText : palette.primary.contrastText),
    },
}));
export const AncillaryButton = withDefaultPropsAndStyles('AncillaryButton', forwardRef(function AncillaryButton(_a, ref) {
    var { inverse } = _a, props = __rest(_a, ["inverse"]);
    const classes = useStyles(props);
    return _jsx(MuiButton, Object.assign({}, props, { className: inverse ? classes.inverse : undefined, ref: ref }), void 0);
}), {
    defaultProps: {
        color: 'default',
        variant: 'text',
    },
});
export const DestructiveButton = withDefaultPropsAndStyles('DestructiveButton', MuiButton, {
    styles: (theme) => ({
        root: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.text.inverse,
            '&:hover': {
                backgroundColor: darken(theme.palette.error.main, 0.15),
            },
        },
    }),
    defaultProps: {
        color: 'primary',
        variant: 'contained',
    },
});
export const CTAButton = withDefaultPropsAndStyles('CTAButton', MuiButton, {
    styles: () => ({
        // NOTE: these empty styles need to exist here in order for the
        // theme-specific overrides to be applied.
        root: {},
        disabled: {},
        containedSecondary: {},
        containedPrimary: {},
    }),
    defaultProps: {
        color: 'inherit',
        variant: 'contained',
    },
});
//# sourceMappingURL=Button.js.map